import { PageHeader } from "@/components/kit";
import { FaqList } from "@/components/FaqList";

export default function FaqPage() {
  return (
    <div data-testid="faq-page">
      <PageHeader eyebrow="Questions fréquentes" title="FAQ" subtitle="Les réponses aux questions que se posent le plus souvent les débutantes." />
      <FaqList />
    </div>
  );
}
